import $i from "~/i18n";
export const getDiscussReply = async ({commit}, payload) => {
  try {
    let { data } = await axios.post("/discuss-reply/get", {
      discuss_id: payload.discuss_id
    });
    if (data.state != 200) {
      return;
    }
    if (data.replies.length == 0) {
      commit(
        "notifications/info",
        { message: "جوابی یافت نشد", title: "" },
        { root: true }
      );
    }
    commit("setReplies", {
      replies: data.replies,
      index: payload.index
    });
  } catch (error) {
    console.log(error);
  }
};
export const getDiscussReplySu = async ({commit}, payload) => {
  try {
    let { data } = await axios.post("/discuss-reply/get-for-su", {
      discuss_id: payload.discuss_id
    });
    if (data.state != 200) {
      return;
    }
    if (data.replies.length == 0) {
      commit(
        "notifications/info",
        { message: "جوابی یافت نشد", title: "" },
        { root: true }
      );
    }
    commit("setReplies", {
      replies: data.replies,
      id: payload.id
    });
  } catch (error) {
    console.log(error);
  }
};
export const discussGet = async (context, payload) => {
  try {
    let { data } = await axios.post("/discuss/get-for-su", {
      published: payload.published
    });
    if (data.state != 200) {
      return;
    }
    context.commit("setListDiscuss", data.discuss);
  } catch (error) {
    console.log(error);
  }
};
export const postDiscussNew = async (context, payload) => {
  try {
    let { data } = await axios.post("/discuss/new", payload);
    if (data.state != 200) {
      return;
    }
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    context.dispatch("discussGet");
  } catch (error) {
    console.log(error);
  }
};
export const discussReplyNew = async (context, payload) => {
  try {
    let { data } = await axios.post(
      "/discuss-reply/new",
      payload.formDiscussReplyNew
    );
    if (data.state != 200) {
      return;
    }
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const updateDiscussNew = async (context, payload) => {
  try {
    let body = { ...payload.item };
    delete body.replies;
    body.discuss_id = body.id;
    delete body.id;
    let { data } = await axios.post("/discuss/update", body);
    if (data.state != 200) {
      return;
    }
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const updateReplie = async (context, payload) => {
  try {
    let body = { ...payload.replie };
    delete body.replies;
    body.discuss_reply_id = body.id;
    delete body.id;
    let { data } = await axios.post("/discuss-reply/update", body);
    if (data.state != 200) {
      return;
    }
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const discussDelete = async (context, payload) => {
  try {
    let { data } = await axios.post("/discuss/delete", { id: payload.id });
    if (data.state != 200) {
      return;
    }
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/discusses/actions.js